module.exports = "<div>\n    <div>\n        <h4>Tables</h4>\n    </div>\n    <ul>\n        <li ng-hide=\"((item.doneLoading) && (item.count === 0))\" ng-repeat=\"item in page.sidebarItems | orderBy: -item.title\" ng-class=\"main.currentMode == item.select ? 'selectedSearchMode' : ''\">\n            <a ng-click=\"page.changeTable(item.select)\"> {{item.title}}</a>\n        </li>\n    </ul>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/main/search_sidebar.html
 ** module id = 861
 ** module chunks = 0
 **/